<script setup>
import { Link } from '@inertiajs/vue3'

defineProps({
  user: { type: Object, required: true },
})
</script>

<template>
  <div class="mt-4">
    <!-- Back affordance: top-left, subtle, breadcrumb-style. Matches iOS HIG /
         Material Up navigation and the Gutenberg primary optical area for
         LTR readers — the eye lands here first when scanning to "exit". -->
    <Link
      :href="route('admin.user.index')"
      class="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800 transition-colors mb-3"
    >
      <i class="pi pi-arrow-left text-xs" />
      <span>{{ $t('messages.admin.user.back_to_list') }}</span>
    </Link>
    <div class="mb-4">
      <h2 class="text-xl font-semibold m-0 leading-tight">
        {{ user.full_name && user.full_name.trim() ? user.full_name : user.email }}
      </h2>
      <div class="text-sm text-gray-500 mt-1">{{ user.email }}</div>
      <div class="flex items-center gap-2 mt-2">
        <Tag v-if="user.blocked" :value="$t('messages.admin.user.blocked_tag')" severity="warn" />
        <Tag v-if="user.deleted_at" :value="$t('messages.admin.user.archived_tag')" severity="secondary" />
        <Tag v-if="!user.password_set" :value="$t('messages.admin.user.invitation_pending_tag')" severity="info" />
      </div>
    </div>
  </div>
</template>
